import { SignUp } from "@clerk/react";
import { Navigate, useLocation } from "react-router-dom";

import { clerkAppearance } from "../auth/clerkAppearance";
import { isPublicRegistrationAttempt } from "../auth/invitationAccess";
import "../auth/Auth.css";
import BrandWordmark from "../components/BrandWordmark";

/**
 * Account activation for someone an administrator invited.
 *
 * OMJ VISION is invite-only: there is no public registration. This is still
 * mounted at `/sign-up/*` because that is where Clerk's invitation email lands
 * by default, carrying a `__clerk_ticket`, and `<SignUp>` is the component that
 * redeems it. `isPublicRegistrationAttempt` — see invitationAccess.js — is what
 * separates an invited user from a visitor who typed the address.
 */
function AcceptInvitationPage() {
  const location = useLocation();

  if (isPublicRegistrationAttempt(location.pathname, location.search)) {
    return <Navigate to="/sign-in" replace />;
  }

  return (
    <main className="auth-shell">
      <section className="auth-card">
        <BrandWordmark size="sm" className="auth-kicker" />

        <div className="auth-clerk">
          <SignUp
            routing="path"
            path="/sign-up"
            signInUrl="/sign-in"
            forceRedirectUrl="/goldbot"
            appearance={clerkAppearance}
          />
        </div>

        <p className="auth-card__note">
          Finish setting up the account your administrator invited.
        </p>
      </section>
    </main>
  );
}

export default AcceptInvitationPage;
